var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGuestKairosLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 153.189,
    height: 27.83,
    viewBox: "0 0 153.189 27.83",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1628",
    "data-name": "Rectangle 1628",
    width: 153.191,
    height: 27.833,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Kairos_Logo"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 153.19,
    height: 27.83
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Kairos_Logo",
    "data-name": "Kairos Logo",
    clipPath: "url(#clip-Kairos_Logo)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_22639",
    "data-name": "Group 22639",
    transform: "translate(-41 -38)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3138",
    "data-name": "Group 3138",
    transform: "translate(41 38)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3137",
    "data-name": "Group 3137",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3136",
    "data-name": "Group 3136",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2539",
    "data-name": "Path 2539",
    d: "M22.815,13.169H16.869L26.8.9H35.57L27.41,10.977a5.914,5.914,0,0,1-4.6,2.192",
    transform: "translate(-10.359 -0.555)",
    fill: "#23cb00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2540",
    "data-name": "Path 2540",
    d: "M11.376,14H3.209A3.209,3.209,0,0,0,0,17.21V27.415H6.414V15.691l11.7,11.724h8.871L15.155,15.562A5.1,5.1,0,0,0,11.376,14M41.948.106,27.816,27.4l.938,0a.635.635,0,0,0,.565-.344l3.961-7.684,12.285.02,3.9,7.694a.635.635,0,0,0,.565.348l6.61.01L42.543.107a.469.469,0,0,0-.6,0M33.882,18.22,39.459,7.452l5.509,10.786ZM3.206,12.614H6.414V.395H0V9.408a3.206,3.206,0,0,0,3.206,3.206M151.486,15.2a11.515,11.515,0,0,0-3.979-2.46c-1.5-.561-3.489-1.18-5.925-1.836-2.06-.57-3.7-1.066-4.873-1.475a8.808,8.808,0,0,1-2.844-1.573A2.816,2.816,0,0,1,132.8,5.617a3.426,3.426,0,0,1,2.111-3.139,12.568,12.568,0,0,1,5.877-1.189,19.869,19.869,0,0,1,2.272.147c.12.019.229.032.357.053a6.941,6.941,0,0,1,4.059,1.777,4.872,4.872,0,0,1,1.49,3.356h2.551a5.019,5.019,0,0,0-1.444-3.44A9.209,9.209,0,0,0,146.1.89,19.8,19.8,0,0,0,140.2.1a20.046,20.046,0,0,0-6.427.963,10.5,10.5,0,0,0-4.508,2.785A6.187,6.187,0,0,0,127.6,8.1a5.229,5.229,0,0,0,1.626,3.914,11.414,11.414,0,0,0,3.817,2.382c1.457.568,3.411,1.2,5.808,1.874,2.123.6,3.805,1.133,5,1.586a9.663,9.663,0,0,1,2.969,1.723A3.076,3.076,0,0,1,147.949,22a3.6,3.6,0,0,1-2.514,3.462,15.274,15.274,0,0,1-6.106,1.166,24.309,24.309,0,0,1-3.13-.193l-.034-.005c-.458-.061-.854-.18-1.283-.268a6.629,6.629,0,0,1-2.813-1.371,5.162,5.162,0,0,1-1.58-3.229h-2.5l0,0h-.9a5.318,5.318,0,0,0,1.578,2.992,10.455,10.455,0,0,0,4.49,2.435,22.975,22.975,0,0,0,6.409.826,23.533,23.533,0,0,0,6.788-.921,11.394,11.394,0,0,0,4.945-2.835,6.551,6.551,0,0,0,1.892-4.73,5.523,5.523,0,0,0-1.7-4.138M118.373,1.778a18.678,18.678,0,0,0-14.911-.024,13.089,13.089,0,0,0-5.54,4.665A13.332,13.332,0,0,0,95.813,14,13.329,13.329,0,0,0,97.9,21.587a13.069,13.069,0,0,0,5.525,4.682,17.933,17.933,0,0,0,7.473,1.564,17.831,17.831,0,0,0,7.438-1.541,13.074,13.074,0,0,0,5.54-4.664,13.336,13.336,0,0,0,2.109-7.581A13.334,13.334,0,0,0,123.9,6.46a13.091,13.091,0,0,0-5.525-4.683m-7.475,24.9c-5.636-.009-8.369-4.152-8.356-12.664s2.761-12.647,8.4-12.637c5.609.009,8.329,4.152,8.315,12.664s-2.747,12.646-8.356,12.637M91.734,13.6A6.172,6.172,0,0,0,94.206,8.2a6.11,6.11,0,0,0-2.2-5.088A10.954,10.954,0,0,0,86.977.948,38.113,38.113,0,0,0,80.74.465L69.574.436v.838h-.007V14.689h3.2A3.209,3.209,0,0,0,75.98,11.48V1.616l4.757.008c2.391,0,4.174.522,5.3,1.541s1.678,2.7,1.674,5.029c0,2.249-.616,3.911-1.82,4.94a7.757,7.757,0,0,1-5.178,1.57.987.987,0,0,0-.772,1.6l8.763,10.953a.632.632,0,0,0,.494.238l7.047.012-9.9-11.932a12.556,12.556,0,0,0,5.39-1.982m-18.96,2.479H69.567V27.45H75.98V19.282a3.206,3.206,0,0,0-3.206-3.206M58.225,27.453l6.413.01L64.681.442,58.268.432Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuestKairosLogo);
export default __webpack_public_path__ + "static/media/GuestKairos Logo.a02d978eb750aff1030a08984df7b602.svg";
export { ForwardRef as ReactComponent };